import React, { useState } from 'react';
import { FilterParams, AuditLog } from '../types/audit';
import { downloadAsCSV, downloadAsJSON } from '../utils/exportHelpers';
import auditAPI from '../services/api';

interface ExportButtonProps {
  filters: FilterParams;
  data?: AuditLog[];
}

const ExportButton: React.FC<ExportButtonProps> = ({ filters, data }) => {
  const [loading, setLoading] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const handleExportCSV = async () => {
    setLoading(true);
    setShowMenu(false);
    try {
      if (data && data.length > 0) {
        // Export current view
        downloadAsCSV(data, `audit-logs-${new Date().toISOString().split('T')[0]}.csv`);
      } else {
        // Export from API
        const blob = await auditAPI.exportToCSV(filters);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `audit-logs-${new Date().toISOString().split('T')[0]}.csv`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }
    } catch (error) {
      console.error('Export failed:', error);
      alert('Failed to export data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleExportJSON = async () => {
    setLoading(true);
    setShowMenu(false);
    try {
      if (data && data.length > 0) {
        // Export current view
        downloadAsJSON(data, `audit-logs-${new Date().toISOString().split('T')[0]}.json`);
      } else {
        // Export from API
        const blob = await auditAPI.exportToJSON(filters);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `audit-logs-${new Date().toISOString().split('T')[0]}.json`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }
    } catch (error) {
      console.error('Export failed:', error);
      alert('Failed to export data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <button
        onClick={() => setShowMenu(!showMenu)}
        disabled={loading}
        style={styles.button}
      >
        {loading ? 'Exporting...' : '📥 Export'}
      </button>

      {showMenu && (
        <div style={styles.menu}>
          <button onClick={handleExportCSV} style={styles.menuItem}>
            Export as CSV
          </button>
          <button onClick={handleExportJSON} style={styles.menuItem}>
            Export as JSON
          </button>
        </div>
      )}
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    position: 'relative',
    display: 'inline-block',
  },
  button: {
    padding: '7px 16px',
    backgroundColor: '#1a7f4b',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '600',
    letterSpacing: '0.01em',
  },
  menu: {
    position: 'absolute',
    top: '100%',
    right: 0,
    marginTop: '4px',
    backgroundColor: 'white',
    border: '1px solid #d8dde6',
    borderRadius: '6px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    zIndex: 1000,
    minWidth: '150px',
    overflow: 'hidden',
  },
  menuItem: {
    display: 'block',
    width: '100%',
    padding: '9px 14px',
    border: 'none',
    background: 'none',
    textAlign: 'left' as const,
    cursor: 'pointer',
    fontSize: '13px',
    color: '#1a2332',
  },
};

export default ExportButton;

